module.exports = __webpack_public_path__ + "img/Download.8511a399.png";